<!-- tablesearchmiscellaneousreimbursement.vue -->

<template>
    <div class="group-image">
        <div>
          <div v-if="isPdf === false">
            <div :class="isPdf === false ? 'img-flex mt-3' : 'img-flex-ispdf mt-3' " v-if="listMidia !== null">
              <div v-for="(data, index) in listMidia" v-bind:key="index"  :class="isPdf ? 'pdf-class' : 'img-body'" @click="!isPdf ? openPopUpMidias(data) : ''">
                    <!-- <img class="icone-img" :src="'data:image/jpg;base64,' + arquivo"/> -->
                    <img class="icone-img" :src="getImageSrc(data.img64)"/>
                    <div v-if="isPdf === false" class="edit-img">
                        <i class="fas fa-eye"></i>
                    </div>
                </div>
            </div>
            <div class="not-found mt-3" v-else>
              <img class="icon-chamado" src="../../../../../../../../../../../../../../../static/img/apr/Image_NotFound.svg">
              <div class="mt-2">Nenhuma imagem foi encontrada</div>
            </div>
          </div>
          <div v-if="isPdf === true">
            <div :class="isPdf === false ? 'img-flex mt-3' : 'img-flex-ispdf mt-3' " v-if="listMidia !== null">
              <div v-for="(data, index) in listMidia" v-bind:key="index"  :class="isPdf ? 'pdf-class' : 'img-body'" @click="!isPdf ? openPopUpMidias(data) : ''">
                    <img class="icone-img" :src="'data:image/jpeg;base64,' + data.img64"/>
                </div>
            </div>
          </div>

        </div>
        <b-modal
          ref="detailsPopUp"
          size="md"
          :hide-footer="true"
          centered
          body-class="p-0"
          >
        <template #modal-title>
          <div class="title-popUp">
            Visualizar Mídias
          </div>
        </template>
        <div class="popUpMidias">
          <div class="m-2" >
            <button v-if="posicao !== 0" class="arrow" @click="backImg()">
              <i class="fas fa-chevron-left" ></i>
            </button>
            <button v-else class="arrowDisabled">
              <i class="fas fa-chevron-left" ></i>
            </button>
          </div>
          <img class="img-details" :src="'data:image/jpeg;base64,' + base64"/>
          <div class="m-2" >
            <button v-if="listMidia && posicao !== listMidia.length - 1" class="arrow" @click="nextImg()">
              <i class="fas fa-chevron-right" ></i>
            </button>
            <button v-else class="arrowDisabled">
              <i class="fas fa-chevron-right" ></i>
            </button>
          </div>
        </div>
        </b-modal>
    </div>
</template>

<script>

import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'

import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'mediaApr',
  components: {HeadDetailsGama},
  data () {
    return {
      coluna: [],
      dataFucionario: [],
      formSearch: {},
      totalDiversos: null,
      base64: null,
      referencia: {},
      posicao: 0
    }
  },
  props: [
    'listMidia',
    'isPdf'],
  mounted () {
  },
  methods: {
    getImageSrc (img64) {
      // APR: backend (Download()) manda base64 CRU, sem prefixo "data:image/...".
      // O startsWith antigo nunca casava -> mime sempre '' -> data URI inválida.
      // Detecta o formato pela assinatura do próprio base64 (evita depender do backend).
      if (img64.startsWith('data:')) return img64
      let mime = 'jpeg'
      if (img64.startsWith('iVBORw0KGgo')) mime = 'png'
      else if (img64.startsWith('R0lGOD')) mime = 'gif'
      else if (img64.startsWith('UklGR')) mime = 'webp'
      return `data:image/${mime};base64,${img64}`
    },
    openPopUpMidias (value) {
      loading.push()
      this.referencia = value
      this.posicao = this.listMidia.indexOf(this.referencia)
      this.base64 = value.img64
      loading.pop()
      this.$refs['detailsPopUp'].show()
    },
    nextImg () {
      this.posicao = this.listMidia.indexOf(this.referencia)
      if (this.posicao > this.listMidia.length) {
        var next = this.listMidia[this.listMidia.length]
      } else {
        next = this.listMidia[this.posicao + 1]
      }
      this.referencia = next
      this.openPopUpMidias(this.referencia)
    },
    backImg () {
      this.posicao = this.listMidia.indexOf(this.referencia)
      if (this.posicao > 0) {
        var next = this.listMidia[this.posicao - 1]
      } else {
        next = this.listMidia[0]
      }
      this.referencia = next
      this.openPopUpMidias(this.referencia)
    }
  }
}

</script>

<style scoped>
.buttons-table-action{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: right;
    align-items: center;
}

.btn-generate-lote {
    height: 2rem;
    padding: 0 1rem;
    background: #008144;
    color: white;
    border-radius: 8px;
    border: none;
    font-weight: bold;
}
.btn-generate-lote:hover{
    background: #024d2a;
}

.form-inputs{
    width: 100%;
    padding: 0.5rem 0;
}
.labelsearch{
    font-weight: 700;
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: 'Segoe UI';
}
.icone-img {
  height: 100%;
  border-radius: 10px;
  width: 100%;
  object-fit: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-flex{
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  column-gap: 0.5rem;
  row-gap: 0.5rem;
}
.img-flex-ispdf{
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  column-gap: 0.5rem;
  row-gap: 0.5rem;
}
.img-body{
  width: calc(95% / 4);
  height: 12rem;
  border-radius: 10px;
  position: relative;
  transition: 400ms;
  cursor: pointer;
}
.pdf-class{
  width: calc(95% / 3);
  height: 150px;
  border-radius: 10px;
  position: relative;
  transition: 400ms;
}
.group-image {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.edit-img{
  height: 34px;
  top: 30px;
  z-index: 5;
  right: 0px;
  width: 40px;
  color: white;
  background-color: #008148;
  border-radius: 8px 0px 0px 8px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.title-popUp{
  font-family: 'Segoe UI';
  font-size: 20px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popUpMidias {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 3rem 0 3rem;
}
.arrow {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color:#008144;
  border-color: transparent;
  border-radius: 100%;
  width: 2rem;
  height: 2rem;
}
.arrowDisabled {
  cursor: not-allowed;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color:#A3A3A3;
  border-color: transparent;
  border-radius: 100%;
  width: 2rem;
  height: 2rem;
}
.img-details {
  width: 100%;
  height: 100%
}
.not-found{
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  font-weight: bold;
    font-size: 17px;
    color:#008148;
    font-family: 'Segoe UI';
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/components/medias/components/mediaApr/mediaApr.vue